import { render, staticRenderFns } from "./BigCandle.vue?vue&type=template&id=a76c0cc2&scoped=true"
import script from "./BigCandle.vue?vue&type=script&lang=js"
export * from "./BigCandle.vue?vue&type=script&lang=js"
import style0 from "./BigCandle.vue?vue&type=style&index=0&id=a76c0cc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a76c0cc2",
  null
  
)

export default component.exports